const size = [
  {
    display: "S",
    size: "S",
  },
  {
    display: "M",
    size: "M",
  },
  {
    display: "L",
    size: "L",
  },
  {
    display: "XL",
    size: "XL",
  },
  {
    display: "XXL",
    size: "XXL",
  },
];
export default size;
